import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCepiMajtas = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 81.204,
	height: 89,
	viewBox: "0 0 81.204 89",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
		id: "linear-gradient",
		x1: .45,
		y1: .95,
		x2: -.488,
		y2: .006,
		gradientUnits: "objectBoundingBox",
		children: [
			/* @__PURE__ */ _jsx("stop", {
				offset: .051,
				stopColor: "#b9752b"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .267,
				stopColor: "#f9d877"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .344,
				stopColor: "#e0b254"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .424,
				stopColor: "#ca9036"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .468,
				stopColor: "#c2842b"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .541,
				stopColor: "#cd953a"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .685,
				stopColor: "#eac162"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .751,
				stopColor: "#f9d877"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .788,
				stopColor: "#ecc468"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .88,
				stopColor: "#d09947"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .952,
				stopColor: "#bf7e32"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .994,
				stopColor: "#b9752b"
			})
		]
	}) }), /* @__PURE__ */ _jsxs("g", {
		id: "Group_7843",
		"data-name": "Group 7843",
		transform: "translate(-50.375 -261.504)",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "Path_9583",
			"data-name": "Path 9583",
			d: "M69.008,332.183V281.926L50.375,261.5v89h81.2l-16.717-18.322Z",
			fill: "url(#linear-gradient)"
		}), /* @__PURE__ */ _jsx("path", {
			id: "Path_9584",
			"data-name": "Path 9584",
			d: "M63.847,340.665V288.014L50.375,273.248v80.8H124.1l-12.213-13.385Z",
			transform: "translate(0 -3.546)",
			fill: "#1d3943"
		})]
	})]
});
export { SvgCepiMajtas as ReactComponent };
